const naturalSort = (a, b) => a.localeCompare(b, navigator.language, { numeric: true, sensitivity: 'base' });

export default naturalSort;
